import { render, staticRenderFns } from "./ProfileBranches.vue?vue&type=template&id=70c1217b&"
import script from "./ProfileBranches.vue?vue&type=script&lang=js&"
export * from "./ProfileBranches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports